// extracted by mini-css-extract-plugin
export default {"model":"Model_model__WTLsa","model__view":"Model_model__view__dC4BZ"};